type TCategory = {
  title: string;
  components: string[];
  defaultExpanded?: boolean;
  visible?: boolean;
};

const categories: Record<string, TCategory> = {
  common: {
    title: "Common",
    components: [
      "Hero",
      "BasicSection",
      "Cta",
      "Reviews",
      "MiniArticles",
      "Contact",
      "Steps",
    ],
  },
  general: {
    title: "General",
    components: [
      "FaqAccordion",
      "ArchStandalone",
      "Cards",
      "Tabs",
      "Video",
      "Features",
      "ComparisonTable",
    ],
  },
  domains: {
    title: "Domains",
    components: [
      "DomainNameBulkSearchResults",
      "DomainNameSearchResults",
      "DomainNamePricingTable",
      "DomainNameSearchBackorder",
      "DomainNamePricingCards",
      "DomainNameSearchTabs",
      "DomainNameSearchTransfer",
      "DomainNameTldSearch",
    ],
  },
  phoneNumbers: {
    title: "Phone Numbers",
    components: [
      "NumberTransfer",
      "NumberPicker",
      "CallRates",
      "CallRatesSearch",
      "SearchLinks",
    ],
  },
  legacy: {
    title: "Legacy",
    components: [
      "LegacyBento",
      "Paragraph",
      "Heading",
      "Button",
      "Image",
      "GridBox",
      "FlexBox",
      "Navigation",
      "Footer",
    ],
  },
};

export default categories;
